import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  paragraphRevealAnimation,
  SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const doubleParagraphRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const overline = selector('[data-motion-overline]')[0]
  const paragraph1 = selector('[data-motion-paragraph-1]')[0]
  const paragraph2 = selector('[data-motion-paragraph-2]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse)
  })

  let overlineAnimation: SharedAnimation
  if (overline) {
    overlineAnimation = linesRevealAnimation(overline, reverse)
    timeline.add(overlineAnimation.timeline, '<')
  }

  let paragraph1Animation: SharedAnimation
  if (paragraph1) {
    paragraph1Animation = paragraphRevealAnimation(paragraph1, reverse)
    timeline.add(paragraph1Animation.timeline, '<+0.2')
  }

  let paragraph2Animation: SharedAnimation
  if (paragraph2) {
    paragraph2Animation = paragraphRevealAnimation(paragraph2, reverse)
    timeline.add(paragraph2Animation.timeline, '<+0.2')
  }

  return () => {
    timeline.kill()

    overlineAnimation?.revert()
    paragraph1Animation?.revert()
    paragraph2Animation?.revert()
  }
}
